var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNear(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1501 48C37.405 48 48.1502 37.2548 48.1502 24C48.1502 10.7452 37.405 0 24.1501 0C10.8953 0 0.150146 10.7452 0.150146 24C0.150146 37.2548 10.8953 48 24.1501 48Z",
    fill: "#050829"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.232 13.2267L26.2242 20.6667C25.8779 21.1733 26.5438 21.7867 27.0233 21.36L31.9512 17.0667C32.0844 16.96 32.2708 17.04 32.2708 17.2267V30.64C32.2708 30.8267 32.0311 30.9067 31.9245 30.7733L17.0078 12.9067C16.5283 12.32 15.8357 12 15.0633 12H14.5305C13.1454 12 12 13.1467 12 14.56V33.44C12 34.8533 13.1454 36 14.5572 36C15.4362 36 16.2619 35.5467 16.7414 34.7733L21.7492 27.3333C22.0954 26.8267 21.4295 26.2133 20.9501 26.64L16.0222 30.9067C15.889 31.0133 15.7026 30.9333 15.7026 30.7467V17.36C15.7026 17.1733 15.9423 17.0933 16.0488 17.2267L30.9656 35.0933C31.4451 35.68 32.1643 36 32.9101 36H33.4428C34.8546 36 36 34.8533 36 33.44V14.56C36 13.1467 34.8546 12 33.4428 12C32.5372 12 31.7114 12.4533 31.232 13.2267Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNear);
export default __webpack_public_path__ + "static/media/Near.21461410929ea19125da0de37dd45f60.svg";
export { ForwardRef as ReactComponent };